if (!customElements.get('product-customer-review-slider')) {
  class ProductCustomerReviewSlider extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.children).filter((child) => child.matches('[data-review-slide]'));

      if (this.items.length <= 1 || typeof Flickity === 'undefined') return;

      this.speed = (parseInt(this.getAttribute('autoplay-speed'), 10) || 8) * 1000;
      this.motionReduced = window.theme?.config?.motionReduced;

      this.slider = new Flickity(this, {
        accessibility: true,
        adaptiveHeight: true,
        cellAlign: 'left',
        contain: true,
        draggable: true,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true,
        rightToLeft: theme.config.rtl,
        autoPlay: !this.motionReduced ? this.speed : false,
      });

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-review-slide]');
          if (!slide) return;

          const index = this.items.indexOf(slide);
          if (index >= 0) this.slider.select(index);
        });
      }
    }

    disconnectedCallback() {
      if (this.slider) this.slider.destroy();
    }
  }

  customElements.define('product-customer-review-slider', ProductCustomerReviewSlider);
}
